import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-content" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"container\"><div class=\"footer\"><a href=\"https://tim.org.tr/tr/cerez-politikasi\" target=\"_blank\">Çerez Politikası </a><a href=\"https://tim.org.tr/tr/kvkk-aydinlatma-metni\" target=\"_blank\">KVKK Aydınlatma Metni </a><a href=\"https://tim.org.tr/tr/bilgi-guvenligi-politikasi\" target=\"_blank\">Bilgi Güvenliği Politikası </a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, { title: _ctx.title }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ]),
      _hoisted_3
    ])
  ], 64))
}